import AuthLayout from './AuthLayout';
import MainLayout from './MainLayout';
import QuickNavigation from './QuickNavigation';

export { AuthLayout, MainLayout, QuickNavigation };



// WEBPACK FOOTER //
// ./src/modules/layout/containers/index.js